const cachePeriodInSec = 3

let lastCacheTime = 0

export default {
    namespaced: true,
    state: {
        loading: false,
        info: {
            users: [],
            username: false
        }
    },
    getters: {
        isLoading: (state) => state.loading,
        isGuest: (state) => state.info.username === false,
        getInfo: (state) => state.info
    },
    mutations: {
        LOADING: (state, value) => { state.loading = value },
        INFO: (state, value) => { state.info = value }
    },
    actions: {
        fetchInfo(ctx, state = {}) {
            let now = Date.now()

            if (state.force !== true && (now - lastCacheTime) < cachePeriodInSec * 1000) {
                return Promise.resolve()
            }

            let options = {
                showLoader: false
            }

            if ( state.silent === true ) {
                options.onErrorNotifyCallback = (APIServiceException) => {
                    console.error(APIServiceException.getMessage())
                }
            }

            return API.GET('login', 'auth-info', {}, options).then(response => {
                lastCacheTime = now

                ctx.commit('INFO', {
                    users: response.getData('users'),
                    username: response.getData('authenticated')
                })
            })
        }
    }
}
